export class Blog {
    constructor(
    /**
     * title of the blog
     */
    title, 
    /**
     * description of the blog
     */
    description) {
        this.title = title;
        this.description = description;
    }
    /**
     * serialize a Blog into
     * a serializable object.
     */
    toObject() {
        return {
            title: this.title,
            description: this.description
        };
    }
    /**
     * create a Blog object from a
     * plain object.
     */
    static from(plainBlog) {
        return new Blog(plainBlog.title, plainBlog.description);
    }
}
//# sourceMappingURL=blog.type.js.map